<template>
	<div>
		<div class="view-framework">
			<userLeft></userLeft>
			<div class="view-framework-body">
				<div class="view-framework-main">
					<div class="box">
						<h2 class="box-caption">我的卖卡记录</h2>
						<div class="form-filter">
							<div class="form-group">
								<label class="control-label">日期筛选</label>
								<el-date-picker
									v-model="value2"
									type="daterange"
									align="center"
									unlink-panels
									range-separator="至"
									start-placeholder="起始日期"
									end-placeholder="结束日期"
									:picker-options="pickerOptions"
									:editable="false"
									size='small'
									@change='optionData'
									value-format="yyyy-MM-dd">
								</el-date-picker>
							</div>
							<div class="form-group">
								<label class="control-label">订单查询</label>
								<input  class="form-control input-long mr10" v-model="keyWord" placeholder="请输入关键字搜索"/>
								<label class="control-label">卖卡状态</label>
								<el-select v-model="orderType" placeholder="请选择" size='small'>
								    <el-option
								      v-for="item in options"
								      :key="item.value"
								      :label="item.label"
								      :value="item.value">
								    </el-option>
								</el-select>
							</div>
							<div class="form-group">
								<button class="btn btn-primary btn-sm btn-square px30" type="submit" @click="search">搜索</button>
								<button class="btn btn-default btn-sm btn-square px30" type="submit" @click="empty">清空</button>
							</div>
						</div>
						<div class="table-responsive">
							  <el-table
							    :data="tableData"
							    stripe
									border
							    style="width: 100%">
							    <el-table-column
							      prop="create_time"
							      label="日期"
							      width="180">
							    </el-table-column>
							    <el-table-column
							      prop="order_no"
							      label="订单号"
										width='250'>
							    </el-table-column>
							    <el-table-column
							      prop="goods_name"
							      label="卡种"
										width='200'>
							    </el-table-column>
									<el-table-column
									  prop="order_price"
									  label="提交面值"
										width='90'>
									</el-table-column>
									<el-table-column label="实际到账" width='90'>
										<template slot-scope="scope">
											<span  class="text-orange">{{scope.row.recycle_price}}</span>
										</template>
									</el-table-column>
									<el-table-column label="交易状态" >
										<template slot-scope="scope">
											<span  class="" :class="{'text-success':scope.row.delivery_status===30,
											'text-red':scope.row.delivery_status===40 || scope.row.delivery_status === 60,
											'text-gray':scope.row.delivery_status===10 || scope.row.delivery_status === 50,
											'text-blue':scope.row.delivery_status === 20
											}">{{delivery_status[scope.row.delivery_status]}}</span>
										</template>
									</el-table-column>
									<el-table-column label="说明" width='250'>
										<template slot-scope="scope">
											<span  class="text-red">{{scope.row.result_message}}</span>
										</template>
									</el-table-column>
									<el-table-column label="操作" width="80">

										<template slot-scope="scope">

											<router-link class="text-blue"  :to="{path:'/orderDetail?orderId='+scope.row.order_no}">查看详情</router-link>
                      <a class="text-red" href="javascript:;" v-if="scope.row.delivery_status === 20" @click="openSettle(scope.row)"  >快速结算</a>
										</template>
									</el-table-column>
							  </el-table>
						</div>
						<div class="text-right">
							    <el-pagination
							      @current-change="handleCurrentChange"
							      :current-page.sync="current_page"
							      :page-size="per_page"
							      layout="prev, pager, next, jumper,total"
										:page-count='last_page'
							      :total="total">
							    </el-pagination>
						</div>
					</div>
				</div>
			</div>
      <!-- custom-class="pop-radius" -->
      		<el-dialog :visible.sync="dialogVisible" title="" width='522px' >
     			<div class="">

      				<div class="userform" style="padding: 0;">
                <div class="text-center">
                  <div v-if="settle.status === 0" class="alcenter flex-center">
                  	<el-icon class="waring-wds ft25"><InfoFilled /></el-icon>
                  	<span class="ft20 ">审核中</span>
                  </div>
                  <div v-if="settle.status === 1" class="alcenter flex-center">
                  	<el-icon class="success-wds ft25"><SuccessFilled /></el-icon>
                  	<span class="ft20 ">结算成功</span>
                  </div>
                  <div v-if="settle.status === 2 || settle.status === 3" class="alcenter flex-center">
                  	<el-icon class="error-wds ft25"><WarningFilled /></el-icon>
                  	<span class="ft20 ">{{settle.status === 2?'可重新提交':"审核驳回"}}</span>
                  </div>
                  <div v-if="settle.status === 4" class="alcenter flex-center">
                    <i class="CircleCloseFilled"></i>
                  	<!-- <i class="error-wds ft25"><CircleCloseFilled /></el-icon> -->
                  	<span class="ft20 ">该订单不支持快速结算</span>
                  </div>
                  <div class="ft18 c_909399 ">
                  	<p v-if="settle.status === 3 || settle.status===2">{{settle.cause}}</p>
                  	<p v-else>{{settle.status === 0?'审核时间为1个工作日，请耐心等待':settle.status===1?'结算成功，请耐心等待1~2分钟':settle.status===4?'到账时间：':''}}</p>
                  	<span  v-if="settle.status===4">{{present.result_date}}</span>
                  </div>
                </div>

      					<div class="divider">
                  <div class="form-group">
                  	<label class="form-label">订单号：</label>
                  	<div class="form-element text-left">
                      {{present.order_no}}
                  	</div>
                  </div>
                  <div class="form-group">
                  	<label class="form-label">卡种：</label>
                  	<div class="form-element text-left">
                      {{present.goods_name}}
                  	</div>
                  </div>
                  <div class="form-group">
                  	<label class="form-label">卡号：</label>
                  	<div class="form-element text-left">
                      {{present.card?present.card:'无卡号'}}
                  	</div>
                  </div>
                  <div class="form-group">
                  	<label class="form-label">卡密：</label>
                  	<div class="form-element text-left" >
                      {{present.card_pass?present.card_pass:'无卡号'}}
                  	</div>
                  </div>
      					</div>
      				</div>
      				<div class="  text-center" >
                <button class="btn btn-primary btn-sm btn-square px30" style="width: 200px;margin-top: 20px;" v-if="settle.status === 2"  @click="openaweWl(present)">重新提交</button>
                <button class="btn btn-default btn-sm btn-square px30" style="width: 200px;margin-top: 20px;"  @click="dialogVisible = false;">关闭</button>
      				</div>
      			</div>
      			<template #footer>
      				<span class="dialog-footer">
      				</span>
      			</template>
      		</el-dialog>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
			 pickerOptions: {
					shortcuts: [{
						text: '今天',
						onClick(picker) {

							picker.$emit('pick', [new Date(), new Date()]);
						}
					},
					{
						text: '最近一周',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '最近一个月',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '最近三个月',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
							picker.$emit('pick', [start, end]);
						}
					}
					]
				},
				options: [{
					value: 11,
					label: '全部'
				}, {
					value: 12,
					label: '处理中'
				}, {
					value: 13,
					label: '待结算'
				}, {
					value: 14,
					label: '成功'
				}, {
					value: 15,
					label: '失败'
				}],
				delivery_status:{
					10:'处理中',
					20:'待结算',
					30:'成功',
					40:'失败',
					50:'待处理',
					60:'异常订单'
				},
				tableData: [],
				value2:[],
				dataFirst: '',
				dataLast:"",
				keyWord:"",
				current_page:1,
				last_page:10,
				per_page:10,
				total:100,
				orderType:11,
        present:{},
        settle:{},
        dialogVisible:false,
			}
		},
		created() {
			this.getOrder()
		},
		methods:{
			search(){
				this.getOrder()
			},
      openaweWl(item){
      	// ,query:{item.order_no}
      	this.$router.push({path:'/settle',query:{order_no:item.order_no}})
      },
      comTime(create_time,last_time,item){
      	let order_no = create_time.split('|')[0]
      	let time = Number(create_time.split('|')[1]);
      	if(order_no != item.order_no){
      		return true
      	}
      	if(Math.floor(Math.abs(last_time - time)) >= 3600){
      		localStorage.removeItem('surveyStatus')
      		return true
      	}else{
      		return false
      	}
      },
      openSettle(item){
      	this.$api.approvalStatus({
      		order_id:item.order_no
      	})
      	.then(result => {
      		this.present = item
      		this.settle = result.data?result.data:{}
      		if(result.code === 1){
      			this.dialogVisible = true
      		}else{
      			let create_time = localStorage.getItem('surveyStatus')
      			let last_time = Date.parse(new Date()) / 1000
      			if(!create_time){
      					this.openaweWl(item)
      			}else{
      				if(this.comTime(create_time,last_time,item)){
      					this.openaweWl(item)
      				}else{
      					this.settle['status'] = 4
                console.log(this.settle)
      					this.dialogVisible = true
      				}
      			}
      		}
      	})

      },
			empty(){
				this.keyWord = ''
				this.value2 = []
				this.dataFirst = ''
				this.dataLast = ''
				this.orderType = 11
				this.current_page = 1
				this.getOrder()
			},
			handleCurrentChange(val) {
				this.current_page = val
				this.getOrder()
			},
			optionData(){
				this.dataFirst = this.value2[0] + ' ' + '00:00:00'
				this.dataLast = this.value2[1] + " " + "23:59:59"
			},
			getOrder(){
				let token = localStorage.getItem('token')
				this.$api.orderList({
					token: token,
					type: this.orderType,
					page: this.current_page,
					start_time: this.dataFirst,
					end_time: this.dataLast,
					name: this.keyWord,
					category_name: ""
				}).then(res => {
					if(res.code === 1){
						this.current_page = res.data.current_page
						this.last_page = res.data.last_page
						this.per_page = res.data.per_page
						this.total = res.data.total

						this.tableData = res.data.data
					}else{

					}
				})
			}
		}
	}
</script>

<style scoped>
  .form-group{
    margin-bottom: 0px!important;
  }
  .ft20{
    font-size: 20px;
  }
  .flex-center{
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/user/order.vue